import { Component } from '@angular/core';
import { Observable, combineLatest } from 'rxjs';
import { InvoiceCreditOverviewComponent } from '../invoice-credit-overview/invoice-credit-overview.component';
import { InvoiceCreditFilterComponent } from '../invoice-credit-filter/invoice-credit-filter.component';
import { SortingComponent, PaginationComponent, IconComponent, SpinnerComponent } from '@spartacus/storefront';
import { NoDisplayResultNoticeComponent } from '../../../shared/components/no-display-result-notice/no-display-result-notice.component';
import { AsyncPipe, DatePipe } from '@angular/common';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'app-credit-bonus-overview',
    templateUrl: './credit-bonus-overview.component.html',
    imports: [InvoiceCreditFilterComponent, SortingComponent, PaginationComponent, IconComponent, NoDisplayResultNoticeComponent, SpinnerComponent, AsyncPipe, DatePipe, TranslatePipe]
})
export class CreditBonusOverviewComponent extends InvoiceCreditOverviewComponent {

  private VIEW_TYPE_BONUS = 'bonuses';

  protected getViewType(): string {
    return this.VIEW_TYPE_BONUS;
  }
  onDowloadSingleDocument(invoiceCreditDocumentNumber: string): void {
    this.selectedInvoiceCreditDocumentNumbers = []
    this.selectedInvoiceCreditDocumentNumbers.push(invoiceCreditDocumentNumber);
    this.onDownloadMultipleDocuments();
  }

  protected getDocumentFileNamesTranslations(): Observable<[string, string]> {
    return combineLatest([
      this.translation.translate('invoicesCreditsCustom.invoiceCreditOverview.downloadCreditDocumentFileNamePrefix'),
      this.translation.translate('invoicesCreditsCustom.invoiceCreditOverview.downloadCreditDocumentsCompressedFileNamePrefix')
    ]);
  }
}
